/*
 * Product page (premium template): tabs or accordion, links into them, size
 * units, carousels, video row, reviews and the Complete the look panel.
 * Loaded by several blocks and sections; runs once.
 */
(function () {
  if (window.pdpPremium) return;
  window.pdpPremium = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  // Height of the sticky header, so a scrolled-to element is not hidden under it
  function headerOffset() {
    var height = 0;
    document.querySelectorAll('#header-group > *, header-component, .shopify-section-group-header-group').forEach(function (element) {
      var position = getComputedStyle(element).position;
      if (position !== 'sticky' && position !== 'fixed') return;
      var box = element.getBoundingClientRect();
      if (box.height > height && box.height < 200) height = box.height;
    });
    return height;
  }

  /* Tabs */

  function selectTab(tab, focus) {
    var list = closest(tab, '[role="tablist"]');
    if (!list) return;
    list.querySelectorAll('[role="tab"]').forEach(function (item) {
      var on = item === tab;
      item.setAttribute('aria-selected', on ? 'true' : 'false');
      item.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
    var box = tab.getBoundingClientRect();
    var listBox = list.getBoundingClientRect();
    if (box.left < listBox.left || box.right > listBox.right) {
      list.scrollTo({ left: tab.offsetLeft - 16, behavior: 'smooth' });
    }
  }

  document.addEventListener('click', function (event) {
    var tab = closest(event.target, '[data-pdpx-tabs] [role="tab"]');
    if (tab) selectTab(tab, false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = closest(event.target, '[data-pdpx-tabs] [role="tab"]');
    if (!tab) return;
    var tabs = [].slice.call(closest(tab, '[role="tablist"]').querySelectorAll('[role="tab"]'));
    var index = tabs.indexOf(tab);
    var next = -1;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    if (next < 0) return;
    event.preventDefault();
    selectTab(tabs[next], true);
  });

  /* Links to #pdp-… open the tab, accordion panel or details they point into, then scroll */

  document.addEventListener(
    'click',
    function (event) {
      var link = closest(event.target, 'a[href^="#pdp-"]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      var panel = closest(target, '[role="tabpanel"]');
      if (panel && panel.hidden) {
        var tab = document.querySelector('[aria-controls="' + panel.id + '"]');
        if (tab) selectTab(tab, false);
      }
      if (target.tagName === 'DETAILS') target.open = true;
      // A target inside an accordion panel: open that panel first
      var details = closest(target, 'details');
      if (details && !details.open) details.open = true;
      requestAnimationFrame(function () {
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    },
    true
  );

  /* Size table: inches or centimetres */

  document.addEventListener('click', function (event) {
    var button = closest(event.target, '[data-pdpx-unit]');
    if (!button) return;
    var wrap = closest(button, '[data-pdpx-size]');
    if (!wrap) return;
    wrap.querySelectorAll('[data-pdpx-unit]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
    wrap.setAttribute('data-unit', button.getAttribute('data-pdpx-unit'));
  });

  /* Carousels: previous / next buttons */

  document.addEventListener('click', function (event) {
    var button = closest(event.target, '[data-pdpx-prev], [data-pdpx-next]');
    if (!button) return;
    var wrap = closest(button, '[data-pdpx-wrap]');
    var track = wrap && wrap.querySelector('[data-pdpx-track]');
    var first = track && track.firstElementChild;
    if (!first) return;
    var step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    track.scrollBy({ left: button.hasAttribute('data-pdpx-prev') ? -step : step, behavior: 'smooth' });
  });

  /* Video row: play without sound while in view, tap for sound */

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                if (!reduceMotion || video.dataset.userPlay) play(video);
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.6] }
        )
      : null;

  function play(video) {
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function initVideos() {
    document.querySelectorAll('.pdpx-ugc video:not([data-pdpx-seen])').forEach(function (video) {
      video.setAttribute('data-pdpx-seen', '');
      video.muted = true;
      video.setAttribute('playsinline', '');
      if (observer) observer.observe(video);
    });
  }

  document.addEventListener('click', function (event) {
    var sound = closest(event.target, '[data-pdpx-sound]');
    if (sound) {
      var video = closest(sound, '.pdpx-ugc__media').querySelector('video');
      if (!video) return;
      var turnOn = video.muted;
      document.querySelectorAll('.pdpx-ugc video').forEach(function (item) {
        item.muted = true;
      });
      document.querySelectorAll('[data-pdpx-sound]').forEach(function (item) {
        item.setAttribute('aria-pressed', 'false');
        item.setAttribute('aria-label', 'Turn sound on');
      });
      if (turnOn) {
        video.muted = false;
        video.dataset.userPlay = '1';
        sound.setAttribute('aria-pressed', 'true');
        sound.setAttribute('aria-label', 'Turn sound off');
        play(video);
      }
      return;
    }
    var clicked = closest(event.target, '.pdpx-ugc__media video');
    if (clicked) {
      if (clicked.paused) {
        clicked.dataset.userPlay = '1';
        play(clicked);
      } else {
        clicked.pause();
      }
    }
  });

  /* Reviews: read more, show more */

  function initReviews() {
    document.querySelectorAll('.pdpx-rc__body:not([data-pdpx-seen])').forEach(function (body) {
      if (body.closest('.pdpx-rc[hidden]')) return;
      body.setAttribute('data-pdpx-seen', '');
      var more = body.nextElementSibling;
      if (more && more.hasAttribute('data-pdpx-readmore') && body.scrollHeight > body.clientHeight + 2) {
        more.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var showMore = closest(event.target, '[data-pdpx-rv-more]');
    if (showMore) {
      var list = closest(showMore, '[data-pdpx-rv]');
      var hidden = list.querySelectorAll('.pdpx-rc[hidden]');
      for (var i = 0; i < hidden.length && i < 6; i++) hidden[i].hidden = false;
      if (hidden.length <= 6) showMore.hidden = true;
      initReviews();
      return;
    }
    var readMore = closest(event.target, '[data-pdpx-readmore]');
    if (readMore) {
      var body = readMore.previousElementSibling;
      var open = body.classList.toggle('is-open');
      readMore.textContent = open ? 'Read less' : 'Read more';
      readMore.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  /* Complete the look: panel to choose options and add to the cart */

  var sheet = null;
  var state = null;
  var opener = null;

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function isColour(name) {
    return /colou?r/i.test(name);
  }

  function buildSheet() {
    sheet = make('dialog', 'pdpx-sheet');
    sheet.setAttribute('aria-labelledby', 'PdpxSheetTitle');
    sheet.innerHTML =
      '<div class="pdpx-sheet__panel">' +
      '<div class="pdpx-sheet__bar"><span class="pdpx-sheet__grab" aria-hidden="true"></span>' +
      '<button type="button" class="pdpx-sheet__close" data-pdpx-close aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button></div>' +
      '<div class="pdpx-sheet__top"><div class="pdpx-sheet__img"><img alt="" width="96" height="120"></div>' +
      '<div class="pdpx-sheet__meta"><p class="pdpx-sheet__name" id="PdpxSheetTitle"></p><p class="pdpx-sheet__desc"></p><p class="pdpx-sheet__price"></p></div></div>' +
      '<div class="pdpx-sheet__opts"></div>' +
      '<p class="pdpx-sheet__msg" role="alert" hidden></p>' +
      '<div class="pdpx-sheet__foot"><button type="button" class="pdpx-sheet__add" data-pdpx-add></button>' +
      '<a class="pdpx-sheet__more" href="#">View full details</a></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (event) {
      if (event.target === sheet || closest(event.target, '[data-pdpx-close]')) {
        closeSheet();
        return;
      }
      var value = closest(event.target, '[data-pdpx-val]');
      if (value) {
        choose(Number(value.getAttribute('data-o')), value.getAttribute('data-pdpx-val'));
        return;
      }
      if (closest(event.target, '[data-pdpx-add]')) add();
    });
    sheet.addEventListener('keydown', function (event) {
      var value = closest(event.target, '[data-pdpx-val]');
      if (!value || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(event.key) < 0) return;
      var group = [].slice.call(closest(value, '[role="radiogroup"]').querySelectorAll('[data-pdpx-val]'));
      var index = group.indexOf(value);
      var step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      var next = group[(index + step + group.length) % group.length];
      event.preventDefault();
      choose(Number(next.getAttribute('data-o')), next.getAttribute('data-pdpx-val'));
      var again = sheet.querySelector('[data-o="' + next.getAttribute('data-o') + '"][aria-checked="true"]');
      if (again) again.focus();
    });
    sheet.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeSheet();
    });
  }

  function availableFor(optionIndex, value) {
    return state.data.variants.some(function (variant) {
      if (!variant.a || variant.o[optionIndex] !== value) return false;
      for (var i = 0; i < optionIndex; i++) {
        if (state.selected[i] != null && variant.o[i] !== state.selected[i]) return false;
      }
      return true;
    });
  }

  function findVariant() {
    return state.data.variants.find(function (variant) {
      return variant.o.every(function (value, i) {
        return state.selected[i] === value;
      });
    });
  }

  function renderOptions() {
    var box = sheet.querySelector('.pdpx-sheet__opts');
    box.innerHTML = '';
    state.data.options.forEach(function (option, optionIndex) {
      var group = make('div', 'pdpx-opt');
      var label = make('p', 'pdpx-opt__label', option.name);
      label.id = 'PdpxOpt' + optionIndex;
      if (state.selected[optionIndex] != null) {
        label.appendChild(document.createTextNode(': '));
        label.appendChild(make('span', null, state.selected[optionIndex]));
      }
      group.appendChild(label);
      var swatches =
        isColour(option.name) &&
        option.values.every(function (value) {
          return value.img || value.c;
        });
      var values = make('div', 'pdpx-opt__vals' + (swatches ? ' pdpx-opt__vals--sw' : ''));
      values.setAttribute('role', 'radiogroup');
      values.setAttribute('aria-labelledby', label.id);
      var checkedAny = state.selected[optionIndex] != null;
      option.values.forEach(function (value, valueIndex) {
        var on = state.selected[optionIndex] === value.v;
        var ok = availableFor(optionIndex, value.v);
        var button = make('button', 'pdpx-val' + (swatches ? ' pdpx-val--sw' : '') + (ok ? '' : ' is-out'));
        button.type = 'button';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', on ? 'true' : 'false');
        button.tabIndex = on || (!checkedAny && valueIndex === 0) ? 0 : -1;
        button.setAttribute('data-pdpx-val', value.v);
        button.setAttribute('data-o', String(optionIndex));
        if (swatches) {
          button.setAttribute('aria-label', value.v + (ok ? '' : ', sold out'));
          button.title = value.v;
          var dot = make('span', 'pdpx-val__dot');
          if (value.img) dot.style.backgroundImage = 'url("' + value.img + '")';
          else dot.style.background = value.c;
          button.appendChild(dot);
        } else {
          button.textContent = value.v;
          if (!ok) button.setAttribute('aria-label', value.v + ', sold out');
        }
        values.appendChild(button);
      });
      group.appendChild(values);
      box.appendChild(group);
    });
  }

  function renderFooter() {
    var missing = [];
    state.data.options.forEach(function (option, i) {
      if (state.selected[i] == null) missing.push(isColour(option.name) ? 'colour' : option.name.toLowerCase());
    });
    var variant = missing.length ? null : findVariant();
    state.variant = variant;

    var shown = variant || state.data.variants.find(function (item) { return item.a; }) || state.data.variants[0];
    var price = sheet.querySelector('.pdpx-sheet__price');
    price.textContent = shown ? shown.p : '';
    if (shown && shown.c) {
      price.appendChild(document.createTextNode(' '));
      price.appendChild(make('s', null, shown.c));
    }

    var colourIndex = state.data.options.findIndex(function (option) { return isColour(option.name); });
    var image = state.data.img;
    var withImage = state.data.variants.find(function (item) {
      if (!item.img) return false;
      if (variant) return item.id === variant.id;
      return colourIndex > -1 && state.selected[colourIndex] != null && item.o[colourIndex] === state.selected[colourIndex];
    });
    if (withImage) image = withImage.img;
    var img = sheet.querySelector('.pdpx-sheet__img img');
    if (image) {
      img.src = image;
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    var button = sheet.querySelector('[data-pdpx-add]');
    if (missing.length) {
      button.disabled = true;
      button.textContent = 'Select ' + missing.join(' & ');
    } else if (!variant || !variant.a) {
      button.disabled = true;
      button.textContent = 'Sold out';
    } else {
      button.disabled = false;
      button.textContent = 'Add to cart';
    }
  }

  function choose(optionIndex, value) {
    state.selected[optionIndex] = value;
    for (var i = optionIndex + 1; i < state.selected.length; i++) {
      if (state.selected[i] != null && !availableFor(i, state.selected[i])) state.selected[i] = null;
    }
    sheet.querySelector('.pdpx-sheet__msg').hidden = true;
    renderOptions();
    renderFooter();
  }

  function openSheet(data, button) {
    if (!sheet) buildSheet();
    opener = button;
    state = { data: data, selected: data.options.map(function () { return null; }), variant: null, busy: false };
    data.options.forEach(function (option, i) {
      if (option.values.length === 1) state.selected[i] = option.values[0].v;
    });
    var colourIndex = data.options.findIndex(function (option) { return isColour(option.name); });
    if (colourIndex > -1 && state.selected[colourIndex] == null) {
      var firstOk = data.options[colourIndex].values.find(function (value) {
        return availableFor(colourIndex, value.v);
      });
      if (firstOk) state.selected[colourIndex] = firstOk.v;
    }
    sheet.querySelector('.pdpx-sheet__name').textContent = data.name;
    var desc = sheet.querySelector('.pdpx-sheet__desc');
    desc.textContent = data.desc || '';
    desc.hidden = !data.desc;
    sheet.querySelector('.pdpx-sheet__more').href = data.url;
    sheet.querySelector('.pdpx-sheet__msg').hidden = true;
    renderOptions();
    renderFooter();
    document.documentElement.classList.add('pdpx-lock');
    sheet.showModal();
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
    });
    var start = sheet.querySelector('[data-pdpx-val][aria-checked="false"][data-o="' + (data.options.length - 1) + '"]') || sheet.querySelector('[data-pdpx-close]');
    if (start) start.focus();
  }

  function closeSheet() {
    if (!sheet || !sheet.open) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('pdpx-lock');
    var done = function () {
      if (sheet.open) sheet.close();
      if (opener) opener.focus();
    };
    if (reduceMotion) done();
    else setTimeout(done, 220);
  }

  function addToCart(id) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw new Error((json && (json.description || json.message)) || 'This item could not be added.');
          return json;
        });
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        showCart(cart, id);
        return cart;
      });
  }

  function showCart(cart, id) {
    if (typeof window.upcartRefreshCart === 'function' || typeof window.upcartOpenCart === 'function') {
      try {
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      } catch (error) {}
      return;
    }
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: String(id), data: { source: 'pdp-look', itemCount: cart.item_count, variantId: String(id) } },
      })
    );
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = root + 'cart';
  }

  function add() {
    var variant = state && state.variant;
    if (!variant || !variant.a || state.busy) return;
    state.busy = true;
    var button = sheet.querySelector('[data-pdpx-add]');
    var message = sheet.querySelector('.pdpx-sheet__msg');
    button.disabled = true;
    button.textContent = 'Adding…';
    addToCart(variant.id)
      .then(function () {
        button.textContent = 'Added';
        opener = null;
        closeSheet();
      })
      .catch(function (error) {
        message.textContent = error.message;
        message.hidden = false;
        renderFooter();
      })
      .then(function () {
        state.busy = false;
      });
  }

  document.addEventListener('click', function (event) {
    var open = closest(event.target, '[data-pdpx-look-open]');
    if (open) {
      var row = closest(open, '.pdpx-look__row');
      var source = row && row.querySelector('script[data-pdpx-look]');
      if (!source) return;
      var data;
      try {
        data = JSON.parse(source.textContent);
      } catch (error) {
        return;
      }
      openSheet(data, open);
      return;
    }
    var direct = closest(event.target, '[data-pdpx-look-add]');
    if (direct) {
      direct.setAttribute('aria-busy', 'true');
      addToCart(Number(direct.getAttribute('data-pdpx-look-add')))
        .catch(function (error) {
          window.alert(error.message);
        })
        .then(function () {
          direct.removeAttribute('aria-busy');
        });
    }
  });

  /* Price row and offer box: follow the chosen variant */

  function formatMoney(cents, format) {
    var match = (format || '').match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    var comma = type.indexOf('comma_separator') > -1;
    var parts = (cents / 100).toFixed(type.indexOf('no_decimals') > -1 ? 0 : 2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var value = parts.join(comma ? ',' : '.');
    return match ? format.replace(match[0], value) : '$' + value;
  }

  document.addEventListener('variant:update', function (event) {
    var variant = event.detail && event.detail.resource;
    if (!variant || variant.price == null) return;
    var section = closest(event.target, '.shopify-section') || document;
    var onSale = variant.compare_at_price > variant.price;
    section.querySelectorAll('[data-pdpx-price]').forEach(function (box) {
      var format = box.getAttribute('data-money');
      var save = box.querySelector('[data-pdpx-save]');
      box.querySelector('[data-pdpx-now]').textContent = formatMoney(variant.price, format);
      box.querySelector('.pdpx-price__was').hidden = !onSale;
      save.hidden = !onSale;
      if (!onSale) return;
      box.querySelector('[data-pdpx-was]').textContent = formatMoney(variant.compare_at_price, format);
      var saved = variant.compare_at_price - variant.price;
      var mode = box.getAttribute('data-format');
      if (mode === 'auto') mode = variant.compare_at_price >= 10000 ? 'amount' : 'percent';
      var text =
        mode === 'amount'
          ? formatMoney(saved, format).replace(/[.,]00(?=\D*$)/, '')
          : Math.round((saved * 100) / variant.compare_at_price) + '%';
      save.textContent = box.getAttribute('data-label') + ' ' + text;
    });
    // Offer box: the same saving, hidden while the chosen variant is not on sale
    section.querySelectorAll('[data-pdpx-offer]').forEach(function (box) {
      box.hidden = !onSale;
      var amount = box.querySelector('[data-pdpx-offer-amount]');
      var price = section.querySelector('[data-pdpx-price]');
      if (onSale && amount && price) {
        // Same format as the saving in the price row: no ,00 on a round amount
        amount.textContent = formatMoney(variant.compare_at_price - variant.price, price.getAttribute('data-money')).replace(/[.,]00(?=\D*$)/, '');
      }
    });
  });

  /* Init, also after the theme editor reloads a section */

  // The review form opens from the Write a review button; after sending it, open it
  // again so the thank-you or error message is seen
  function initReviewForm() {
    document.querySelectorAll('.pdpx-rv__form').forEach(function (form) {
      if (!form.open && form.querySelector('.pdpx-form__ok, .pdpx-form__err')) {
        form.open = true;
        form.scrollIntoView({ block: 'center' });
      }
    });
  }

  function init() {
    initVideos();
    initReviews();
    initReviewForm();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
